module.exports = __webpack_public_path__ + "static/media/only_girl.dd4b9286.png";